export default __webpack_public_path__ + "static/media/white-watch.e1049dd3.png";